var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16992 6.44L10.9999 11.55L19.7699 6.47",
    stroke: "#0044EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.61V11.54",
    stroke: "#0044EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92965 1.48004L3.58965 4.44004C2.37965 5.11004 1.38965 6.79004 1.38965 8.17004V13.82C1.38965 15.2 2.37965 16.88 3.58965 17.55L8.92965 20.52C10.0696 21.15 11.9396 21.15 13.0796 20.52L18.4196 17.55C19.6296 16.88 20.6196 15.2 20.6196 13.82V8.17004C20.6196 6.79004 19.6296 5.11004 18.4196 4.44004L13.0796 1.47004C11.9296 0.840037 10.0696 0.840037 8.92965 1.48004Z",
    stroke: "#0044EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox);
export default __webpack_public_path__ + "static/media/icon_box.f22698f6ddd11bfb090011fdb6cc1dce.svg";
export { ForwardRef as ReactComponent };